import React from 'react';
import { Button, Form, Input } from 'antd';
import { tid } from '@utils/test';
import { StyledButtons } from '../styled';

const { TextArea } = Input;

interface EditorProps {
  onChange: (e: React.ChangeEvent<HTMLTextAreaElement>) => void;
  onSubmit: () => void;
  value: string;
  onClear: () => void;
}

const Editor = ({ onChange, onSubmit, value, onClear }: EditorProps) => {
  // TODO: loading state
  // const submitting = useSelector(isCommentSubmitting);
  // loading={submitting}
  return (
    <>
      <Form.Item>
        <TextArea
          showCount={true}
          rows={2}
          autoSize={{ maxRows: 2, minRows: 2 }}
          onChange={onChange}
          value={value}
          maxLength={140}
          placeholder="Add your comment. (140 characters limit)."
        />
      </Form.Item>
      <Form.Item>
        <StyledButtons>
          <Button size="small" onClick={onClear} {...tid('clear-annotation-comment')}>
            Clear
          </Button>
          <Button
            htmlType="submit"
            size="small"
            onClick={onSubmit}
            type="primary"
            {...tid('add-annotation-comment')}
          >
            Add
          </Button>
        </StyledButtons>
      </Form.Item>
    </>
  );
};

export default Editor;
